import React from 'react';
import './ChevronDownIcon.scss'

const ChevronDownIcon = ({ width, height, transform }) => {
  return (
    <svg className='chevron-down-icon' width={width} height={height} transform={transform} viewBox="0 0 15 9" xmlns="http://www.w3.org/2000/svg">
      <title>Chevron Up Icon</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M.707.61l7.071 7.072-.707.707L0 1.318z" />
        <path d="M13.925.354L6.854 7.425l.707.707 7.07-7.07z" />
      </g>
    </svg>
  );
};

export default ChevronDownIcon;
